import IcEye from './IcEye'

export default IcEye
